// extracted by mini-css-extract-plugin
module.exports = {"container":"container_1eAdh","socialLink":"socialLink_3U7hK"};